<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

    @Component({
        props: {
            WorkspaceId: Number,
            ProjectId: Number,
            EvalModelId: Number,
            ScoringEnabled: Boolean,
            ActivePage: String
        }
    })
    export default class GoalNavigation extends Vue
    {
        get workspaceId(): number { return this.$props.WorkspaceId as number; }
        get projectId(): number { return this.$props.ProjectId as number; }
        get evalModelId(): number { return this.$props.EvalModelId as number; }
        get scoringEnabled(): boolean { return this.$props.ScoringEnabled as boolean; }

        get url_CriteriaPage(): string { return dynamicUiRoutes.Criteria_CriteriaPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }
        get url_RankingPage(): string { return dynamicUiRoutes.Evaluation_RankingPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }
        get url_WeightsPage(): string { return dynamicUiRoutes.Criteria_WeightsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }
        get url_MeasurementsPage(): string { return dynamicUiRoutes.Criteria_MeasurementsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId, this.scoringEnabled); }
        get url_WeightedScoresPage(): string { return dynamicUiRoutes.Criteria_WeightedScoresPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }
        get url_ScoringPanelsPage(): string { return dynamicUiRoutes.Evaluation_ScoringPanelsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }
    }

</script>

<template>
    <div>
        <ul class="nav nav-pills">
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-hierarchy'}">
                <a class="nav-link" v-sanitizedHref="url_CriteriaPage">
                    Criteria
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'measurement'}">
                <a class="nav-link" v-sanitizedHref="url_MeasurementsPage">
                    Measurement
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-surveys'}">
                <a class="nav-link" v-sanitizedHref="url_WeightsPage">
                    Weights
                </a>
            </li>
            <li class="nav-item" v-if="ScoringEnabled" :class="{'active2': ActivePage === 'scoring-surveys'}">
                <a class="nav-link" v-sanitizedHref="url_ScoringPanelsPage">
                    Scoring
                </a>
            </li>
            <li class="nav-item" v-if="!ScoringEnabled" :class="{'active2': ActivePage === 'weighted-scores'}">
                <a class="nav-link" v-sanitizedHref="url_WeightedScoresPage">
                    Scores
                </a>
            </li>

            <li class="nav-item" :class="{'active2': ActivePage === 'results'}">
                <a class="nav-link" v-sanitizedHref="url_RankingPage">
                    Ranking
                </a>
            </li>
        </ul>
        <hr style="border-color: #bbb; margin: 0 0 60px;" />
    </div>
</template>

<style scoped>
    .nav-pills li a {
        border-radius: 0;
        color: black;
        background-color: transparent;
    }

       .nav-pills li a:hover {
            color: gray;
        }


   .nav-pills li.active2 {
        border-bottom: 3px solid blue;
    }

        .nav-pills li.active2 a {
            color: blue;
        }

</style>